import { useEffect, useState } from "react";
import { Sparkles, Zap, WifiOff } from "lucide-react";
import { useNetworkHealth } from "@/lib/resilience/networkHealth";

/**
 * SafeModeUI — discreet, premium banner shown only when the network
 * profile degrades. Auto-hides after a few seconds; brand-friendly copy.
 */
export function SafeModeUI() {
  const h = useNetworkHealth();
  const [visible, setVisible] = useState(false);
  const [lastProfile, setLastProfile] = useState(h.profile);

  useEffect(() => {
    if (h.profile === lastProfile) return;
    setLastProfile(h.profile);
    if (h.profile === "degraded" || h.profile === "critical") {
      setVisible(true);
      const id = window.setTimeout(() => setVisible(false), 5_000);
      return () => window.clearTimeout(id);
    }
    setVisible(false);
  }, [h.profile, lastProfile]);

  if (!visible) return null;

  const critical = h.profile === "critical";
  const Icon = !h.online ? WifiOff : critical ? Zap : Sparkles;
  const message = !h.online
    ? "Sin conexión — manteniendo la experiencia con datos guardados…"
    : critical
    ? "⚡ Ajustando experiencia para conexión inestable…"
    : "⚠️ Optimizando experiencia en tiempo real…";

  return (
    <div
      role="status"
      aria-live="polite"
      className="pointer-events-none fixed left-1/2 top-3 z-[9997] -translate-x-1/2"
    >
      <div className="flex items-center gap-2 rounded-full border border-border/60 bg-background/85 px-3 py-1.5 text-[11px] font-bold text-foreground shadow-lg backdrop-blur-md">
        <Icon className={`h-3.5 w-3.5 ${critical ? "text-amber-500" : "text-primary"}`} />
        <span>{message}</span>
      </div>
    </div>
  );
}
